import { fetchApi } from "@/lib/api-helpers";
import { agreementsResponseSchema } from "@/networking/agreements.types";

export {
  agreementSchema,
  agreementsResponseSchema,
  type Agreement,
} from "@/networking/agreements.types";

export async function fetchAgreements(id: string, language_iso: string) {
  return fetchApi({
    endpoint: `/agreements/${id}?language_iso=${language_iso}`,
    method: "GET",
    outputSchema: agreementsResponseSchema,
  });
}
